var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubdomainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.64,
    viewBox: "0 0 24 24.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "signs-post-solid",
    d: "M17.11,1.54H9.41A1.538,1.538,0,0,0,7.87,3.08V6.16A1.538,1.538,0,0,0,9.41,7.7H27.572a.773.773,0,0,0,.544-.226l2.31-2.31a.773.773,0,0,0,0-1.088l-2.31-2.31a.773.773,0,0,0-.544-.226H20.19a1.54,1.54,0,1,0-3.08,0ZM29.43,12.32a1.538,1.538,0,0,0-1.54-1.54h-7.7V9.24H17.11v1.54H9.728a.773.773,0,0,0-.544.226l-2.31,2.31a.773.773,0,0,0,0,1.088l2.31,2.31a.773.773,0,0,0,.544.226H27.89a1.538,1.538,0,0,0,1.54-1.54ZM20.19,23.1V18.48H17.11V23.1a1.54,1.54,0,1,0,3.08,0Z",
    transform: "translate(-6.65)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubdomainIcon);
export default __webpack_public_path__ + "static/media/subdomain-icon.5f583a6bdddb267b2a8433f1f08b0682.svg";
export { ForwardRef as ReactComponent };